import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";
import logo from "../../assets/logo-footer.png";

const Footer = () => {
  return (
    <div className="bg-black text-white py-16 px-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div>
          <img className="w-32 md:w-1/2" src={logo} alt="Logo" />
        </div>
        <div
          to=""
          className="mt-6 md:mt-0 bg-white text-black px-6 py-3 rounded-full flex items-center gap-2 shadow-md hover:shadow-lg transition"
        >
          Talk to our Support Team
          <span className="ml-2">→</span>
        </div>
      </div>

      <div className="border-t border-gray-700 my-8"></div>

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="flex flex-col md:flex-row items-center">
          <span className="text-gray-400 mb-4 md:mb-0 md:mr-6">
            Reach us via socials
          </span>
          <div className="flex space-x-4">
            <Link
              to="/instagram"
              className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-600 hover:border-white transition"
              aria-label="Instagram"
            >
              <FaInstagram className="text-xl" />
            </Link>
            <Link
              to="/twitter"
              className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-600 hover:border-white transition"
              aria-label="Twitter"
            >
              <FaTwitter className="text-xl" />
            </Link>
            <Link
              to="/linkedin"
              className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-600 hover:border-white transition"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="text-xl" />
            </Link>
          </div>
        </div>

        <div className="text-center md:text-right text-gray-400 mt-6 md:mt-0">
          <p>Copyright © TP Global Ltd</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
